import React from 'react';
import { soundService } from '../services/SoundService';
import { hapticService } from '../services/HapticService';
import './LessonCard.css';

/**
 * LessonCard Component
 * Displays lesson preview in list
 */
function LessonCard({
  lesson,
  isLocked = false,
  isCompleted = false,
  progress = 0,
  onClick
}) {
  if (!lesson) return null;
  
  const { id, title, subtitle, description, difficulty, duration, points, thumbnail } = lesson;

  const handleClick = () => {
    if (!isLocked && onClick) {
      soundService.playClick();
      hapticService.light();
      onClick(lesson);
    }
  };

  const getStatusIcon = () => {
    if (isLocked) return '🔒';
    if (isCompleted) return '✅';
    if (progress > 0) return '▶️';
    return '📖';
  };

  return (
    <div 
      className={`lesson-card ${isLocked ? 'locked' : ''} ${isCompleted ? 'completed' : ''}`}
      onClick={handleClick}
    >
      {/* Thumbnail */}
      <div 
        className="lesson-thumbnail"
        style={{ 
          backgroundColor: thumbnail?.color || '#3776ab',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '24px'
        }}
      >
        {thumbnail?.image ? (
          <img 
            src={`/assets/media/${thumbnail.image}`} 
            alt={title}
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.parentElement.innerHTML = '📚';
            }}
          />
        ) : (
          <span>📚</span>
        )}
      </div>

      {/* Content */}
      <div className="lesson-info">
        <h3 className="lesson-title">{title || 'Untitled Lesson'}</h3>
        {subtitle && <p className="lesson-subtitle">{subtitle}</p>}

        <div className="lesson-meta">
          {difficulty && (
            <span className={`difficulty-badge ${difficulty}`}>
              {difficulty}
            </span>
          )}
          
          {duration && (
            <span>⏱️ {duration}</span>
          )}

          {points && (
            <span>⭐ +{points} XP</span>
          )}
        </div>
      </div>

      {/* Status Icon */}
      <div className="lesson-status">
        <span className="status-icon">{getStatusIcon()}</span>
      </div>
    </div>
  );
}

export default LessonCard;